import { imageSelectedHandler } from "./imageSelectedHandler.function";

export async function processImages(
  productImages,
  setPatienceTimer,
  setIsCompressing
) {
  // Initialize a variable to hold the product images to be uploaded
  let productImagesToUpload;
  // Check if there are any product images to process
  if (productImages.length > 0) {
    // Set a timer to show a patience message after 4 seconds
    setTimeout(() => {
      setPatienceTimer(true);
    }, 4000);
    // Indicate that image compression is in progress
    setIsCompressing(true);
    // Map over each product image to compress it
    const compressedImages = productImages.map(async (item) => {
      // Handle the file selection for each image
      const handledFiles = await imageSelectedHandler(item);
      return handledFiles;
    });
    // Wait for all images to be compressed and then proceed
    productImagesToUpload = await Promise.all(compressedImages).finally(() => {
      // Once all images are compressed, stop the compression indicator
      setIsCompressing(false);
      // Hide the patience message
      setPatienceTimer(false);
    });
  } else {
    productImagesToUpload = [];
  }
  return productImagesToUpload;
}
